import {
  Box,
  Button,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { CustomEvent, Map } from "schemas/functions";

import { isValidHttpUrl } from "utils/string";
import { makeDeepCopy } from "utils/updateLocalState";

import styles from "../styles";

interface PortfolioFormProps {
  handleBack?: () => void;
  handleNext?: () => void;
  handleSkip?: () => void;
  onboardingForm: Map;
  setOnboardingForm: Dispatch<SetStateAction<Map>>;
  isProfilePage?: boolean;
}

const PortfolioForm = ({
  handleBack,
  handleNext,
  handleSkip,
  onboardingForm,
  setOnboardingForm,
  isProfilePage = false,
}: PortfolioFormProps) => {
  const [portfolioValidation, setPortfolioValidation] = useState<
    string | undefined
  >();

  const onSubmit = (e: CustomEvent) => {
    e.preventDefault();

    if (portfolioValidation) {
      return;
    }

    if (handleNext) handleNext();
  };

  const handlePortfolioBlurred = (e: CustomEvent) => {
    const { value } = e.target;

    const sanitizedInput = value.trim();

    if (sanitizedInput && !isValidHttpUrl(sanitizedInput)) {
      setPortfolioValidation("Link must start with http:// or https://");
    } else {
      setPortfolioValidation(undefined);
    }
  };

  const handlePortfolioChange = (e: CustomEvent) => {
    const { name, value } = e.target;

    const sanitizedInput = value.trim();

    const copy = makeDeepCopy(onboardingForm);
    copy[name] = sanitizedInput;
    setOnboardingForm(copy);

    if (isValidHttpUrl(sanitizedInput)) {
      setPortfolioValidation(undefined);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      {!isProfilePage && (
        <Typography
          variant="h3"
          gutterBottom
          sx={{ textAlign: "center", mb: 3 }}
        >
          <Box
            component="i"
            color="secondary.dark"
            sx={{ pr: 2 }}
            className="fa-solid fa-address-card"
          />
          Share Your Portfolio
        </Typography>
      )}

      <Grid item xs={12}>
        <FormHelperText sx={styles.helperText}>
          Portfolio / website URL
        </FormHelperText>
        <TextField
          sx={styles.textField}
          fullWidth
          name="portfolioUrl"
          placeholder="https://www.blog.com"
          onChange={handlePortfolioChange}
          onBlur={handlePortfolioBlurred}
          error={!!portfolioValidation}
          helperText={portfolioValidation}
          value={onboardingForm?.portfolioUrl || ""}
        />
      </Grid>

      {!isProfilePage && (
        <Grid
          container
          justifyContent="flex-start"
          columnGap={1}
          sx={{ mt: 2 }}
        >
          <Grid item xs="auto">
            <Button onClick={handleBack} color="secondary" disableElevation>
              Back
            </Button>
          </Grid>
          <Grid item xs></Grid>
          {handleSkip && (
            <Grid item xs="auto">
              <Button onClick={handleSkip} color="secondary" disableElevation>
                Skip
              </Button>
            </Grid>
          )}
          <Grid item xs="auto">
            <Button disableElevation type="submit" variant="contained">
              Next
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default PortfolioForm;
